import { gql } from '@apollo/client'

export const BOOKING_ATTACHMENT_QUERY = gql`
  query BookingAttachments($reservationCode: String!) {
    bookingAttachments(reservationCode: $reservationCode) {
      url
      label
    }
  }
`
export const UPLOAD_BOOKING_ATTACHMENT_MUTATION = gql`
  mutation UploadBookingAttachment(
    $reservationCode: String!
    $label: String!
    $file: Upload!
  ) {
    uploadBookingAttachment(
      reservationCode: $reservationCode
      label: $label
      file: $file
    ) {
      url
    }
  }
`

export const DELETE_BOOKING_ATTACHMENT_MUTATION = gql`
  mutation DeleteBookingAttachment($id: String!) {
    deleteBookingAttachment(id: $id) {
      message
    }
  }
`
